export var API_PREFIX_URL = '/insights_platform';
export var CACHE_TIMES = {
    THIRTY_SECONDS: 1000 * 30,
    ONE_MINUTE: 1000 * 60,
    TWO_MINUTES: 1000 * 60 * 2,
    FIVE_MINUTES: 1000 * 60 * 5,
    SIXTY_MINUTES: 1000 * 60 * 60
};
export var CACHE_KEYS = {
    RULESETS: 'rulesets',
    RECURRING_PROJECTS: 'recurring_projects',
    PROJECT_VALIDATION: 'project_validation',
    PROJECTS: 'projects',
    PROJECT: 'project',
    PROJECT_COSTS: 'project_costs',
    PROJECT_REVIEW: 'project_review',
    RESULTS: 'results',
    CAMPAIGN_RESULTS: 'campaign_results',
    NEXT_LAUNCH_ESTIMATES: 'next_launch_estimates',
    TAP_SURVEY: 'tap_survey',
    QUALIFICATION: 'qualification',
    QUALIFICATIONS: 'qualifications',
    CAMPAIGN_QUALIFICATION: 'campaign_qualification',
    CAMPAIGN_QUALIFICATIONS: 'campaign_qualifications',
    PAYMENT_METHODS: 'payment_methods',
    PROJECT_WAVES: 'project_waves',
    PROJECT_STATUSES_COUNT: 'project_statuses_count',
    PROJECT_ROOT_QUESTIONS: 'project_root_questions',
    LONGITUDINAL_QUESTION_RESULTS: 'longitudial_question_results',
    QUESTION_ROOT_TAP_ANSWERS: 'question_root_tap_answers',
    TAP_SURVEY_QUESTIONS: 'tap_survey_questions',
    SINGLE_SURVEY_QUESTION_RESULTS: 'single_survey_question_results',
    SINGLE_SURVEY_CROSS_TAB_QUESTION_RESULTS: 'single_survey_cross_tab_question_results',
    QUESTION_TAP_ANSWERS_LIST: 'question_tap_answers_list',
    QUALIFICATION_ANSWER_LABELS: 'qualification_answer_labels',
    CAMPAIGN_QUOTA_FEASIBILITY: 'campaign_quota_feasibility'
};
